import { createSelector } from '@reduxjs/toolkit'
import { MagentoCmsPage } from 'lib/types'
import { RootState } from 'lib/core/data/reducer'

export const getPayload = (state: RootState): MagentoCmsPage[] => {
  return state.common.pageList.payload
}

export const getFetching = (state: RootState): boolean => {
  return state.common.pageList.isFetching
}

export const getPageList = createSelector(
  getPayload,
  items => {
    const identifierIndex: Record<string, MagentoCmsPage> = {}

    items.forEach(item => {
      identifierIndex[item.identifier] = item
    })

    return {
      list: items,
      identifier: identifierIndex
    }
  }
)
